import React from 'react';
import { AppConfigProvider, WindowConfigProvider, LocaleConfigProvider } from '@swuif/config';
import { AuthProvider } from '@swuif/auth';
export var SwuifApp = function SwuifApp(_ref) {
  var config = _ref.config,
      auth = _ref.auth,
      children = _ref.children;
  return React.createElement(WindowConfigProvider, config.window, React.createElement(AppConfigProvider, config.app, React.createElement(LocaleConfigProvider, config.locale, React.createElement(AuthProvider, auth, children))));
};
SwuifApp.defaultProps = {
  config: {}
};